<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pb-0">
            <h6>庫存掃描器</h6>
            <p class="text-sm mb-0">掃描商品或訂單 QR Code</p>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="p-4 text-center">
              <div class="mb-4">
                <input
                  ref="scannerInput"
                  type="text"
                  v-model="scanInput"
                  @keyup.enter="handleScan"
                  class="form-control form-control-lg text-center"
                  placeholder="在此掃描 QR Code..."
                  autofocus
                />
                <small class="text-muted"
                  >點擊輸入框並掃描，或手動輸入代碼。</small
                >
              </div>

              <button
                @click="handleScan"
                class="btn btn-primary btn-lg w-100 mb-3"
              >
                <i class="fas fa-qrcode me-2"></i> 處理掃描
              </button>

              <div v-if="lastScan" class="alert alert-info text-white">
                最後掃描: <strong>{{ lastScan }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <inbound-modal
      :visible="showInbound"
      :product-id="scannedProductId"
      @close="showInbound = false"
      @success="handleSuccess"
      @error="handleError"
    />

    <outbound-modal
      :visible="showOutbound"
      :order-id="scannedOrderId"
      @close="showOutbound = false"
      @success="handleSuccess"
      @error="handleError"
    />
  </div>
</template>

<script>
import InboundModal from "@/components/InboundModal.vue";
import OutboundModal from "@/components/OutboundModal.vue";

export default {
  name: "InventoryScanner",
  components: {
    InboundModal,
    OutboundModal,
  },
  data() {
    return {
      scanInput: "",
      lastScan: "",
      showInbound: false,
      showOutbound: false,
      scannedProductId: null,
      scannedOrderId: null,
    };
  },
  mounted() {
    this.$refs.scannerInput.focus();
  },
  methods: {
    handleScan() {
      const code = this.scanInput.trim();
      if (!code) return;

      this.lastScan = code;
      this.scanInput = ""; // Clear input for next scan

      // Determine if Product or Order
      // Assuming Order starts with 'ORD' and Product is numeric ID or specific format
      // Adjust logic based on actual QR content format

      if (code.startsWith("ORD")) {
        // It's an Order (Need to find ID from Order Number first, or assume QR contains ID)
        // For simplicity, let's assume QR contains "ORD:ID" or we fetch by number
        // Here we'll assume the QR code IS the order number, and we need to fetch ID
        this.fetchOrderByNumber(code);
      } else {
        // Assume it's a Product ID
        this.scannedProductId = code;
        this.showInbound = true;
      }
    },
    async fetchOrderByNumber(orderNumber) {
      // Support multiple QR code formats:
      // - "ORDER:{ID}" - from backend API
      // - "O:{ID}" - from frontend QR display
      // - "ORD..." - order number format
      // - "P:{ID}" - product ID
      try {
        if (orderNumber.startsWith("ORDER:")) {
          // Backend generated format
          this.scannedOrderId = orderNumber.substring(6);
          this.showOutbound = true;
        } else if (orderNumber.startsWith("O:")) {
          // Frontend generated format
          this.scannedOrderId = orderNumber.substring(2);
          this.showOutbound = true;
        } else if (orderNumber.startsWith("P:")) {
          // Product format
          this.scannedProductId = orderNumber.substring(2);
          this.showInbound = true;
        } else if (orderNumber.startsWith("ORD")) {
          // Order number format - need to search for ID
          this.$toast.error(
            '請掃描格式為 "O:{ID}" 或 "ORDER:{ID}" 的訂單 QR Code'
          );
        } else {
          // Assume Product ID
          this.scannedProductId = orderNumber;
          this.showInbound = true;
        }
      } catch (error) {
        console.error(error);
        this.$toast.error("處理掃描失敗");
      }
    },
    handleSuccess(msg) {
      this.$toast.success(msg);
      this.$refs.scannerInput.focus();
    },
    handleError(msg) {
      this.$toast.error(msg);
      this.$refs.scannerInput.focus();
    },
  },
};
</script>
